var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6666 18.5238C18.3848 18.5238 19.7777 17.0741 19.7777 15.2857C19.7777 13.4974 18.3848 12.0476 16.6666 12.0476C14.9484 12.0476 13.5555 13.4974 13.5555 15.2857C13.5555 17.0741 14.9484 18.5238 16.6666 18.5238ZM16.6666 16.9048C15.8075 16.9048 15.1111 16.1799 15.1111 15.2857C15.1111 14.3915 15.8075 13.6667 16.6666 13.6667C17.5257 13.6667 18.2222 14.3915 18.2222 15.2857C18.2222 16.1799 17.5257 16.9048 16.6666 16.9048Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.66663 15.1805C9.66663 11.2118 12.8035 8 16.6666 8C20.5298 8 23.6666 11.2118 23.6666 15.1805C23.6666 17.1409 22.8962 18.9769 21.5628 20.3123L17.2121 24.7675C16.9094 25.0775 16.4239 25.0775 16.1212 24.7676L11.7646 20.3067C10.4323 18.9657 9.66663 17.1348 9.66663 15.1805ZM20.478 19.1519C21.5166 18.1117 22.1111 16.695 22.1111 15.1805C22.1111 12.112 19.6763 9.61905 16.6666 9.61905C13.6569 9.61905 11.2222 12.112 11.2222 15.1805C11.2222 16.6904 11.813 18.1032 12.8507 19.1477L16.6666 23.0549L20.478 19.1519Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.e784954b9c770adc54bd2f32cd2491b1.svg";
export { ForwardRef as ReactComponent };